import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { Box, Collapse, IconButton } from '@mui/material'

import { useExpandable } from '@tabeeb/shared/utils/hooks'
import { Subheader3, Tooltip } from '@collaborate-health/uikit'

export interface CollapsibleSectionProps {
  title: string
  children: React.ReactNode
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({ title, children }) => {
  const { expanded, onCollapse, onExpand } = useExpandable(true)

  return (
    <Box>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Subheader3>{title}</Subheader3>

        <Tooltip text={expanded ? 'Collapse' : 'Expand'}>
          <IconButton size='small' onClick={expanded ? onCollapse : onExpand}>
            {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </Tooltip>
      </Box>

      <Collapse in={expanded}>
        <Box>{children}</Box>
      </Collapse>
    </Box>
  )
}

export default CollapsibleSection

